<template>
  <div class="list">
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <!--Start Linke Seite/Filter-->
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
              :disabled="listTab === 2"
            ></head-menu-filter>
            <div class="row">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['name']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.surname") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['vorname']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.firstname") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.status"
                        :options="aktivitaetsstati"
                        :reduce="(s) => s.id"
                        label="bezeichnung"
                        :placeholder="$t('global.status')"
                        multiple
                      >
                        <span slot="no-options">{{
                          $t("global.nostatusfound")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.status") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" v-show="!rolleProp">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-if="rollen"
                        v-model="filters.rolle"
                        :reduce="(r) => r.id"
                        :options="rollen"
                        label="bezeichnung"
                        :placeholder="$t('global.partnerrole')"
                        multiple
                      >
                        <span slot="no-options">{{
                          $t("global.notypefound")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.partnerrole") }}</label>
                    </div>
                  </div>
                </div>
<!--                 <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['korrAddress']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.address") }}</label>
                    </div>
                  </div>
                </div> -->
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['kanton']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.canton") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.korrespondenzsprache"
                        :options="sprachen"
                        :reduce="(s) => s.id"
                        label="bezeichnung"
                        :placeholder="$t('global.language')"
                        multiple
                      >
                        <span slot="no-options">{{
                          $t("global.nolanguagefound")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.language") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12 my-2">
                    <div class="form-group-inline" style="margin-left: 7px">
                      <label
                        class="float-left"
                        style="
                          font-size: 11px !important;
                          font-weight: 700 !important;
                        "
                        >{{ $t("global.onlywithoperation") }}</label
                      ><input
                        class="form-check-input float-right mx-3"
                        style="margin-top: 0.2rem"
                        v-model="filters.mitEinsatz"
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" v-if="filters.mitEinsatz">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.einsatzSaison"
                        :options="saisons"
                        :reduce="(s) => s.id"
                        label="label"
                        :placeholder="$t('global.seasonoperation')"
                      ></v-select>
                      <label>{{ $t("global.seasonoperation") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="filters.mitEinsatz">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.einsatzStatus"
                        :options="einsatzstati"
                        :reduce="(s) => s.id"
                        label="bezeichnung"
                        :placeholder="$t('global.operationalstatus')"
                        multiple
                      ></v-select>
                      <label>{{ $t("global.operationalstatus") }}</label>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-xl-12 my-2">
                    <div class="form-group-inline" style="margin-left: 7px">
                      <label
                        class="float-left"
                        style="
                          font-size: 11px !important;
                          font-weight: 700 !important;
                        "
                        >{{ $t("global.no_communication_adress") }}</label
                      ><input
                        class="form-check-input float-right mx-3"
                        style="margin-top: 0.2rem"
                        v-model="filters['keine_kommunikationsadresse']"
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div> -->
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group" id="number-of-records">
                      <input
                        v-model="filters.count"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.numberofrecords") }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button
                  @searchWithFilter="filterSearch"
                  @resetFilter="clearFilter"
                  :disabled="listTab === 2"
                />
                <!--Oder Statement switch-->
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <button
                        class="btn btn-secondary"
                        @click="toggleOrParameter"
                        :disabled="listTab === 2"
                        :title="
                          listTab === 2 ? $t('global.pleasechangethetab') : ''
                        "
                      >
                        {{
                          filters.orStatement
                            ? $t("global.orfilteractive")
                            : $t("global.orfilterinactive")
                        }}
                      </button>
                    </div>
                  </div>
                </div>
                <!--Ende Oder Statement switch-->
              </div>
            </div>
          </div>
        </div>
        <!--Ende Linke Seite/Filter-->

        <!--Start RechteSeite-->
        <!--Start Headline/Buttonbar-->
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="
                rolleProp && rolleObj
                  ? rolleObj.bezeichnung
                  : $t('global.people')
              "
              :date="'Mittwoch 29.Juli'"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row d-flex justify-content-between px-4 flex-wrap">
                  <router-link
                    v-if="
                      rolleProp && berechtigungen.m_geschaeftspartner.create
                    "
                    class="btn btn-primary mr-2 mb-1"
                    :to="{
                      name: 'NeuerGeschäftspartnerMitRolle',
                      params: { rolleProp: rolleProp },
                    }"
                  >
                    <font-awesome-icon icon="fa-regular fa-plus" />
                    {{
                      rolleProp && rolleObj
                        ? rolleObj.bezeichnung
                        : $t("global.businesspartner")
                    }}
                    {{ $t("global.add") }}
                  </router-link>
                  <router-link
                    v-if="
                      !rolleProp && berechtigungen.m_geschaeftspartner.create
                    "
                    class="btn btn-success mr-2 mb-1"
                    :to="{
                      name: 'GeschaeftspartnerNewViva',
                      params: { anzeige: 0 },
                    }"
                  >
                    <font-awesome-icon icon="fa-regular fa-plus" />
                    {{ $t("global.new") }}
                  </router-link>

                  <!-- <div style="display: inline-flex" class="mr-2 mb-1">
                    <massenmutation-button
                      :propEntities="propEntities"
                      @mutated="refresh"
                      :selectedIds="this.selectedIds"
                    />
                  </div> -->

                  <b-dropdown
                    variant="primary mr-2 mb-1"
                    v-if="berechtigungen.m_korrespondenz.update"
                  >
                    <template slot="button-content">
                      <font-awesome-icon
                        icon="fa-regular fa-envelope"
                        class="mr-2"
                      />
                      {{ $t("global.createmassmail") }}
                    </template>
                    <b-dropdown-item @click="massenmailErstellen(true)">
                      {{ $t("global.selected") }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="massenmailErstellen(false)">
                      {{ $t("global.alldisplayed") }}
                    </b-dropdown-item>
                  </b-dropdown>

                  <b-dropdown
                    variant="primary mr-2 mb-1"
                    v-if="berechtigungen.m_korrespondenz.update"
                  >
                    <template slot="button-content">
                      <font-awesome-icon
                        icon="fa-regular fa-envelope"
                        class="mr-2"
                      />
                      {{ $t("global.createserialletter") }}
                    </template>
                    <b-dropdown-item
                      @click="massenkorrespondenzErstellen(true)"
                    >
                      {{ $t("global.selected") }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="massenkorrespondenzErstellen(false)"
                    >
                      {{ $t("global.alldisplayed") }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <!-- <button
                    class="btn btn-primary mr-2 mb-1"
                    v-if="berechtigungen.m_geschaeftspartner.create"
                    @click="oeffneDublettenCheckModal"
                  >
                    <font-awesome-icon
                      icon="fa-duotone fa-user-group"
                      class="mr-2"
                    />{{ $t("global.duplicatecheck") }}
                  </button> -->
                  <button
                    class="btn btn-primary mr-2 mb-1"
                    @click="exportToExcel(listData, 'personen')"
                  >
                    <span class="mr-2"
                      ><font-awesome-icon icon="fa-regular fa-file-spreadsheet"
                    /></span>
                    {{ $t("global.export") }}
                  </button>

                  <button
                    class="btn btn-danger ml-auto mb-1"
                    v-if="berechtigungen.m_geschaeftspartner.delete"
                    @click="oeffneLoeschenModal"
                    :disabled="selectedIds.length === 0"
                    :title="
                      selectedIds.length === 0 ? $t('global.selectminone') : ''
                    "
                  >
                    <font-awesome-icon
                      icon="fa-duotone fa-trash"
                      class="mr-2"
                    />{{ $t("global.delete") }}
                  </button>
                </div>
              </div>
            </div>
            <!--Ende Headline/Buttonbar-->

            <!--Start Liste-->

            <!-- Start Reiter Liste / Selected -->
            <div class="reiterrow row d-flex">
              <div
                class="listenreiter"
                :class="{ active: listTab === 1 }"
                @click="handleTabChange(1)"
                v-tooltip.hover
                :title="$t('global.foundentries')"
              >
                <font-awesome-icon
                  v-if="listTab === 1"
                  icon="fa-solid fa-list"
                />
                <font-awesome-icon
                  v-if="listTab === 2"
                  icon="fa-light fa-list"
                />
              </div>
              <div
                class="listenreiter"
                :class="{
                  active: listTab === 2,
                  disabled: selectedIds.length === 0,
                }"
                @click="handleTabChange(2)"
                v-tooltip.hover
                :title="
                  $t('global.selectedentries') + ': ' + selectedIds.length
                "
              >
                <font-awesome-icon
                  v-if="listTab === 2"
                  icon="fa-solid fa-check-square"
                />
                <font-awesome-icon
                  v-if="listTab === 1"
                  icon="fa-light fa-check-square"
                />
                &nbsp;
                <span>{{
                  selectedIds.length > 0 ? selectedIds.length : ""
                }}</span>
              </div>
            </div>
            <!-- End Reiter Liste / Selected -->
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listTab === 1 ? listData : selectedObjects"
                    :fields="fields"
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template
                      slot="top-row"
                      slot-scope="{ fields }"
                      v-if="listTab === 1"
                    >
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <div class="form-group p-0 m-0">
                          <input
                            class="form-control"
                            v-if="
                              field.key != 'selected' &&
                              field.searchable != false
                            "
                            size="sm"
                            type="text"
                            v-model="filters[field.key]"
                            :placeholder="field.label"
                            autocomplete="off"
                          />
                        </div>
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        :checked="header.selected"
                        @change="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        :checked="row.item.selected"
                        @change="onRowSelected(row)"
                        :key="row.item.id + '-' + row.item.selected"
                      ></b-form-checkbox>
                    </template>
                    <template v-slot:cell(telefon)="row">
                      {{
                        row.item.telefon_g ||
                        row.item.telefon_mobil ||
                        row.item.telefon_p
                      }}
                    </template>
                    <template v-slot:cell(kanton)="row">
                      {{
                        row.item.adressen &&
                        row.item.adressen.length > 0
                          ? row.item.adressen[0].kanton
                          : ""
                      }}
                    </template>
                  </b-table>
                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="($state) => infiniteHandler($state, 'app-api')"
                  >
                    <div slot="spinner">
                      {{ $t("global.loadmorebusinesspartners") }}
                    </div>
                    <div slot="no-more">
                      {{ $t("global.nofurtherbusinesspartners") }}
                    </div>
                    <div slot="no-results">
                      {{ $t("global.nofurtherbusinesspartnersfound") }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
            <!--Ende Liste-->
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="geschaeftspartner-loeschen-modal"
      :selectedIds="selectedIds"
      :multiple="true"
      @confirmed="geschaeftspartnerLoeschen"
    />

    <pdf-layer
      id="pdf-layer"
      ref="pdfLayer"
      :src="{
        url: pdfPath,
        withCredentials: true,
      }"
    ></pdf-layer>

    <loading-overlay v-show="loading"></loading-overlay>

    <messagebox-count
      :headerText="$t('global.personsdeleted')"
      id="count-delete-alert-msgbox"
      :ok="true"
      :cancel="false"
      :okText="$t('global.ok')"
      :cancelText="$t('global.cancel')"
    />

    <!-- <portal-zugang-erstellen-messagebox
      :id="'portal-zugang-erstellen-msgbox'"
      :ok="true"
      :cancel="true"
      :okText="portalZugangOkText"
      :cancelText="$t('global.cancel')"
      @ok="createPortalZugang"
    />

    <portal-zugang-success-messagebox
      :id="'portal-zugang-success-msgbox'"
      :ok="true"
      :cancel="false"
    /> -->

    <dubletten-check-modal id="dubletten-check-modal" />
    <dubletten-zusammenfuehren-modal
      id="dubletten-zusammenfuehren-modal"
      :selectedIds="selectedIds"
    />
  </div>
</template>

<script>
import Api from "@/api/Api";
//import PortalApi from "@/PortalApi";
import App from "@/api/AppApi";

import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";
import excelExport from "@/mixins/ExcelExport";

//import MessageboxEnhanced from "@/components/Modals/MessageboxEnhanced.vue";
//import PortalZugangErstellenMessagebox from "@/components/Modals/MessageboxEnhanced.vue";
//import PortalZugangSuccessMessagebox from "@/components/Modals/MessageboxEnhanced.vue";
// import MassenmutationButton from "@/components/Buttons/MassenmutationButton";

import store from "@/store";
import server from "@/server";
import { LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER } from "@/store/geschaeftspartner/actions.type";
import { LADE_VERSANDLISTEN } from "@/store/korrespondenz/actions.type";
import page from "@/mixins/Page";
import dashboard from "@/mixins/Dashboard";
import filterNew from "@/mixins/FilterNew";
import { addresseToSingleLineString } from "@/models/Adresse";
import DublettenCheckModal from "@/components/crm/DublettenCheckModal.vue";
import DublettenZusammenfuehrenModal from "@/components/crm/DublettenZusammenfuehrenModal.vue";
import { LADE_AUSWAHLWERTE_EINSTELLUNGEN } from "@/store/einstellungendashboard/actions.type";
import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";
import { saisonOptions, saisonVon, saisonBis } from "@/utils/Saison";

export default {
  name: "GeschaeftspartnerlisteNewViva",
  components: {
    Navbar,
    LoeschenModal,
    HeadMenu,
    HeadMenuFilter,
    //MessageboxEnhanced,
    // MassenmutationButton,
    FilterSearchResetButton,
    DublettenCheckModal,
    DublettenZusammenfuehrenModal,
    //PortalZugangErstellenMessagebox,
    //PortalZugangSuccessMessagebox,
  },
  metaInfo() {
    const rolleObj = this.rolleObj;

    return {
      titleTemplate: () => {
        return rolleObj
          ? "BX: " + rolleObj.bezeichnung
          : "BX: " + this.$t("global.persons");
      },
    };
  },
  mixins: [page, dashboard, excelExport, filterNew],
  props: {
    rolleProp: {
      type: String,
      required: false,
      default: null,
    },
  },
  store,
  data() {
    return {
      name: "Geschaeftspartnerliste",
      infiniteId: +new Date(),
      pdfPath: "",
      selected: [],
      selectedIds: [],
      msgboxOkText: this.$t("global.ok"),
      /*portalZugangText: this.$t(
        "global.wouldyouliketosendtheinvitationtoregisteronportal"
      ),
      portalZugangOkText: this.$t("global.createportalaccess"),*/
      firstVisit: true,
      propEntities: [
        {
          tbl_name: "bxc_geschaeftspartner",
          selectedIds: [],
        },
      ],
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "nummer",
          sortable: true,
          label: this.$t("global.number"),
          tdClass: "col-number",
        },
        { key: "name", sortable: true, label: this.$t("global.surname") },
        {
          key: "vorname",
          sortable: true,
          label: this.$t("global.firstname"),
        },
        {
          key: "mailadressen[0].bezeichnung",
          sortable: true,
          label: this.$t("global.email"),
        },
        {
          key: "telefon",
          sortable: true,
          label: this.$t("global.phone"),
        },
        {
          key: "kanton",
          sortable: true,
          label: this.$t("global.canton"),
        },
        {
          key: "aktivitaetsstatus.bezeichnung",
          sortable: true,
          searchable: false,
          class: "text-center",
          label: this.$t("global.status"),
        },
      ];
    },
    queryParams: function () {
      var params = {};

      params.nummer = this.setQueryParam(this.filters.nummer);
      params.name = this.setQueryParam(this.filters["name"]);
      params.vorname = this.setQueryParam(this.filters["vorname"]);
      params.status = this.setQueryParamList(this.filters.status);
      params.funktion = this.setQueryParam(this.filters["funktion"]);
      params.korrAddress = this.setQueryParam(this.filters["korrAddress"]);
      params.kanton = this.setQueryParam(this.filters["kanton"]);
      params.rollen = this.rolleProp
        ? this.setQueryParam(this.rolleProp)
        : this.setQueryParamList(this.filters.rolle);
      params.email = this.setQueryParam(
        this.filters["mailadressen[0].bezeichnung"]
      );

      params.korrespondenzsprache = this.setQueryParamList(
        this.filters["korrespondenzsprache"]
      );
      params.interesse = this.setQueryParamList(this.filters.interesse);
      params.konkordat = this.setQueryParamList(this.filters.konkordat);
      params.fbereich = this.setQueryParamList(this.filters.funktionsbereich);
      params.versand = this.setQueryParamList(this.filters.versand);
      params.institution = this.setQueryParamList(this.filters.institution);
      params.keine_kommunikationsadresse = this.setQueryParam(
        this.filters["keine_kommunikationsadresse"]
      );

      // Einsatz-Filter: Saison und Status gelten nur zusammen mit "Nur mit Einsatz"
      if (this.filters.mitEinsatz) {
        params.mitEinsatz = "true";
        params.einsatzStatus = this.setQueryParamList(this.filters.einsatzStatus);
        params.einsatzVon = saisonVon(this.filters.einsatzSaison);
        params.einsatzBis = saisonBis(this.filters.einsatzSaison);
      }

      params.filterCount = this.setQueryParam(this.filters.count);
      params.orStatement = this.setQueryParam(
        this.filters.orStatement ? "true" : undefined
      );
      params.typ = "17EF8844E6B";
      params.incf = "1";

      return params;
    },

    sprachen: {
      get() {
        return this.$store.state.einstellungendashboard.sprachen;
      },
    },

    saisons() {
      return saisonOptions();
    },
    einsatzstati() {
      return this.$store.state.crm.einsatzstati;
    },

    rollen: {
      get() {
        return this.$store.state.geschaeftspartner.partnerrollen;
      },
    },
    funktionsbereiche: {
      get() {
        return this.$store.state.geschaeftspartner.funktionsbereiche;
      },
    },
    interessen: {
      get() {
        return this.$store.state.geschaeftspartner.interessen;
      },
    },
    aktivitaetsstati: {
      get() {
        return this.$store.state.geschaeftspartner.aktivitaetsstati;
      },
    },
    versandlisten: {
      get() {
        return this.$store.state.korrespondenz.versandlisten;
      },
    },
    konkordate: {
      get() {
        return this.$store.state.geschaeftspartner.konkordate;
      },
    },
    institutionen: {
      get() {
        return this.$store.state.geschaeftspartner.institutionen;
      },
    },

    rolleObj() {
      if (this.rolleProp && this.rollen)
        return this.rollen.find((r) => r.id === this.rolleProp);
      return null;
    },
    headline() {
      if (this.rolleProp && this.rollen) {
        let rolle = this.rollen.find((r) => r.id === this.rolleProp);
        if (rolle) return rolle.bezeichnung;
      }
      return "BX: " + this.$t("global.contacts");
    },
  },
  watch: {},
  created() {
    if (this.rollen.length == 0)
      this.$store.dispatch(
        `geschaeftspartner/${LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER}`
      );

    if (this.versandlisten.length == 0)
      this.$store.dispatch(`korrespondenz/${LADE_VERSANDLISTEN}`);

    if (this.einsatzstati?.length === 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);

    this.initFilter("geschaeftspartner-liste", "geschaeftspartner/liste", true);
  },
  mounted() {
    if (this.sprachen.length == 0) {
      this.$store.dispatch(
        `einstellungendashboard/${LADE_AUSWAHLWERTE_EINSTELLUNGEN}`
      );
    }

    if (!this.filters.status && this.firstVisit) {
      // Setzen des Standardwerts nur beim ersten Besuch
      this.$set(this.filters, "status", ["1737FA777AA"]);
      this.firstVisit = false; // Markieren, dass der erste Besuch abgeschlossen ist
    }

    this.$bus.$emit("searchWithFilter");
    //TODO: Mandantenspezifisches FrontEnd sauber loesen
    if (location.href.includes("healthspot")) {
      this.showLoginErstellenButton = true;
    }
  },
  methods: {
    adresse(geschaeftspartner) {
      if (geschaeftspartner.hauptadresse)
        return addresseToSingleLineString(geschaeftspartner.hauptadresse);
      else return "";
    },
    toggleOrParameter() {
      if (this.filters.orStatement) {
        this.$set(this.filters, "orStatement", false);
      } else {
        this.$set(this.filters, "orStatement", true);
      }
      this.filterSearch();
    },

    geschaeftspartnerLoeschen() {
      this.delete("geschaeftspartner/", this.selectedIds);
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0) {
        this.$bus.$emit(
          "openLoeschenModal",
          "geschaeftspartner-loeschen-modal"
        );
      } else {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nopersonsselected"),
        });
      }
    },

    // oeffneLoginErstellenModal() {
    //   if (this.selectedIds.length > 0) {
    //     this.msgboxOkText = `${this.$t("global.ok")} (${
    //       this.selectedIds.length
    //     })`;
    //     let text = this.$t("global.createLoginInquiry");

    //     this.$bus.$emit("openMessageBoxEnhanced", {
    //       id: "create-login-alert-msgbox",
    //       text: text,
    //     });
    //   }
    // },

    ausgebenAvery365221() {
      let ids = this.selectedIds.join(",");
      let filename = new Intl.DateTimeFormat("ch").format(new Date());

      this.pdfPath =
        server.url +
        `/pdfgenerator/pdf.act?filename=AV${filename}.pdf&report=/pdfgenerator/avery-3652-21.htm&ids=${ids}`;
      this.$refs.pdfLayer.show();
    },

    ausgebenAvery365314() {
      let ids = this.selectedIds.join(",");
      let filename = new Intl.DateTimeFormat("ch").format(new Date());

      this.pdfPath =
        server.url +
        `/pdfgenerator/pdf.act?filename=AV${filename}.pdf&report=/pdfgenerator/avery-3653-14.htm&ids=${ids}`;
      this.$refs.pdfLayer.show();
    },

    ausgebenZweckform478427() {
      let ids = this.selectedIds.join(",");
      let filename = new Intl.DateTimeFormat("ch").format(new Date());

      this.pdfPath =
        server.url +
        `/pdfgenerator/pdf.act?filename=AV${filename}.pdf&report=/pdfgenerator/zweckform-4784-27.htm&ids=${ids}`;
      this.$refs.pdfLayer.show();
    },

    massenmailErstellen(selected) {
      if (!selected || this.selectedIds.length > 0) {
        let tempList = selected
          ? this.selectedIds
          : this.$refs.selectableTable.items.map((item) => item.id);

        let json = {
          empfaenger: tempList,
          isMassMail: true,
          inhalt: "",
          zeitpunkt: new Intl.DateTimeFormat("ch").format(new Date()),
        };

        Api.post("mail/", json, { params: {} }).then((response) => {
          this.$router.push({
            name: "mail",
            params: {
              id: response.data.id,
              anzeige: 0,
            },
          });
        });
      } else
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nopersonsselected"),
        });
    },

    massenkorrespondenzErstellen(selected) {
      if (!selected || this.selectedIds.length > 0) {
        let tempList = selected
          ? this.selectedIds
          : this.$refs.selectableTable.items.map((item) => item.id);

        let json = {
          empfaenger: [],
          person: [], // ist de facto person. Noch unsauber im Backend
          isMassKorrespondenz: true,
          versand: {
            erstelltvon: this.angemeldeterMitarbeiter.person,
            datum: new Intl.DateTimeFormat("ch").format(new Date()),
            ort: this.$CONST("CONFIG").MANDANTSTADT,
            betreff: "",
          },
          inhalt: "",
          zeitpunkt: new Intl.DateTimeFormat("ch").format(new Date()),
        };

        json.empfaenger = tempList;
        json.person = tempList;

        Api.post("korrespondenz/", json, { params: {} }).then((response) => {
          Api.post("korrespondenz/empfaenger/", json, {
            params: {
              korrespondenz: response.data.id,
              isPerson: true,
              isMassCorr: true,
            },
          }).then((empfresponse) => {}),
            this.$router.push({
              name: "korrespondenz",
              params: {
                id: response.data.id,
                anzeige: 0,
              },
            });
        });
      } else
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nopersonselected"),
        });
    },

    details(geschaeftspartner) {
      this.$router.push({
        name: "GeschaeftspartnerNewViva",
        params: { id: geschaeftspartner.id, anzeige: 0 },
      });
    },

    refresh() {
      this.resetLoading(this);
    },

    oeffneDublettenCheckModal() {
      this.$bus.$emit("open-modal", "dubletten-check-modal");
    },
    oeffneDublettenZusammenfuehrenModal() {
      this.$bus.$emit("open-modal", "dubletten-zusammenfuehren-modal");
    },
    /*oeffnePortalZugangErstellenModal() {
      this.$bus.$emit("openMessageBoxEnhanced", {
        id: "portal-zugang-erstellen-msgbox",
        text: this.portalZugangText,
        headerText: this.$t("global.createportalaccess"),
      });
    },*/
    // createPortalZugang() {
    //   //TODO: Genauere Infos angeben, welche Logins nicht geklappt haben (fehlende Mailadresse oder bereits vorhandenes Login)
    //   PortalApi.post("registration/mail/", this.selectedIds).then(
    //     (response) => {
    //       console.log(response);
    //       this.$bus.$emit("openMessageBoxEnhanced", {
    //         id: "portal-zugang-success-msgbox",
    //         text: "Portal-Zugänge erfolgreich erstellt",
    //         headerText: this.$t("global.actionsuccessful"),
    //       });
    //     }
    //   );
    // },
    druckeTischkarten() {
      if (this.selectedIds?.length > 0 && this.selectedIds?.length < 150) {
        let ids = this.selectedIds.join(",");

        let filename = this.$t("global.placecards");

        this.pdfPath =
          server.url +
          `/pdfgenerator/pdf.act?filename=${filename}.pdf&report=/pdfgenerator/tischkarten-pdf.htm&landscape=true&ids=${ids}`;
        this.$refs.pdfLayer.show();
      } else if (this.selectedIds?.length > 150) {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.toomanyentriesselected"),
        });
      } else {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nopersonselected"),
        });
      }
    },
    druckeAdressEtiketten() {
      if (this.selectedIds?.length > 0 && this.selectedIds?.length < 150) {
        let ids = this.selectedIds.join(",");

        let filename = this.$t("global.addresslabels");

        this.pdfPath =
          server.url +
          `/pdfgenerator/pdf.act?filename=${filename}.pdf&report=/pdfgenerator/adress-etiketten-pdf.htm&ids=${ids}`;
        this.$refs.pdfLayer.show();
      } else if (this.selectedIds?.length > 150) {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.toomanyentriesselected"),
        });
      } else {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nopersonselected"),
        });
      }
    },
    druckeNamensschilder() {
      if (this.selectedIds?.length > 0 && this.selectedIds?.length < 150) {
        let ids = this.selectedIds.join(",");

        let filename = this.$t("global.nametags");

        this.pdfPath =
          server.url +
          `/pdfgenerator/pdf.act?filename=${filename}.pdf&report=/pdfgenerator/namensschilder-pdf.htm&ids=${ids}`;
        this.$refs.pdfLayer.show();
      } else if (this.selectedIds?.length > 150) {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.toomanyentriesselected"),
        });
      } else {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nopersonselected"),
        });
      }
    },
  },
};
</script>

<style></style>
